import { useParameter } from "../../../shared";

export function useForecastFootnote() {
  const [commodity] = useParameter<number>('@commodities');
  const [sources] = useParameter<string[]>("@sources");

  switch (commodity) {
    case 201: return "Corn, no. 2, Yellow, U.S. Gulf, FOB, USD/mt";
    case 701: return "Rapeseed, EU CIF, Hamburg, USD/mt";
    case 1001: return "Rice, Milled, 100% Grade B, Sacked, FOB, Thailand, USD/mt";
    case 1101: return "Soybeans, EU CIF, Rotterdam, USD/mt";
    case 1201: return "Raw Sugar, London, Refined, USD/mt";
    case 103: return "Wheat, no. 1, HRW, Gulf, FOB, USD/mt";
    default: return "";
  }
}